import React from 'react';

const RequestDemoHeader = () => {
  return (
    <>
    <section
          className='page-header position-relative overflow-hidden ptb-120 bg-dark'
        >
          <div className='container'>
            <div>
              <div className='col-lg-8 col-md-12'>
                <h1>Request Demo</h1>
              </div>
            </div>
          </div>
        </section>
    </>
  );
};

export default RequestDemoHeader;
